export default __webpack_public_path__ + "static/media/certified-sustainable-seafood-by-msc.26af31b9.svg";